




import { Component, Vue } from "vue-property-decorator";

@Component
export default class Consent extends Vue {}

const component = Consent;
